import { render, staticRenderFns } from "./CategoryGraph.vue?vue&type=template&id=71760040"
import script from "./CategoryGraph.vue?vue&type=script&lang=js"
export * from "./CategoryGraph.vue?vue&type=script&lang=js"
import style0 from "./CategoryGraph.vue?vue&type=style&index=0&id=71760040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports